import React, { useContext } from 'react';
import addDays from 'date-fns/add_days';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import LocaleContext from '../../context/locale';

const hideForSkus = ['PKG-F3L-BASIC'];

const LeadTime = ({ value, sku, ...props }) => {
  const { t } = useTranslation();
  const locale = get(useContext(LocaleContext), 'dateLocale', null);
  if (value === '0') {
    return <div {...props}>{t('In Stock!')}</div>;
  }

  if (hideForSkus.includes(sku)) {
    return null;
  }

  return (
    <div {...props}>
      {t('Lead time')}:{' '}
      {distanceInWordsStrict(new Date(), addDays(new Date(), value), {
        locale,
        partialMethod: 'ceil'
      })}
    </div>
  );
};

export default LeadTime;
